<template>
  <div style="text-align:center" >
    <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2021033294号-1</a>
  </div>
</template>